export default {
  article_details: "Article Details",
  asset_details: "Asset Details",
  asset_list: "Asset List",
  assign_amount: "Assign Amount",
  attributeSets: "Attribute Sets",
  detailView: "Detail View",
  new_customer_request: "New Custom",
  request_details: "Request Details",
  generalInfo: "General Information",
  currentMetrics: "Current metrics",
  technicalData: "Technical Data",
  fcsSetup: "Asset Hierarchy/Commissioning",
  systemInfo: "System Informationen",
  assignedTo: "Assigned to",
  recentActivity: "Recent activity",
  fleetInfo: "Deployment Group Information",
  backendServiceOverview: "Backend Services Overview",
};
